import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcCart(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 2.25a.75.75 0 0 0 0 1.5h1.78a.25.25 0 0 1 .236.17l3.317 9.95a2.75 2.75 0 0 0 2.608 1.88h7.173a2.75 2.75 0 0 0 2.575-1.784l1.753-4.676a2.25 2.25 0 0 0-2.107-3.04H9.5a.75.75 0 0 0 0 1.5h10.336a.75.75 0 0 1 .702 1.013l-1.754 4.676a1.25 1.25 0 0 1-1.17.811h-7.173a1.25 1.25 0 0 1-1.185-.855L5.939 3.447A1.75 1.75 0 0 0 4.28 2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 22a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M18 22a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  }));
}
var IcCart = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCart));

export { IcCart as I };
